import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { EffectsModule } from "@ngrx/effects";
import { StoreModule } from "@ngrx/store";

import { ShopsService } from "@hermes/shop-utils";
import { ShellStateModule } from "@hermes/states/shell";

import { ShopLocatorEffects } from "./effects/shop-locator.effects";
import { ShopLocatorFacade } from "./facades/shop-locator.facade";
import {
    reducer,
    shopLocatorFeatureKey,
} from "./reducers/shop-locator.reducer";

@NgModule({
    imports: [
        CommonModule,
        ShellStateModule,
        EffectsModule.forFeature([ShopLocatorEffects]),
        StoreModule.forFeature(shopLocatorFeatureKey, reducer),
    ],
    providers: [ShopsService, ShopLocatorFacade],
})
export class ShopLocatorStateModule {}
